(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .constant('REFRESH_CONST', {
            REFRESH_ALL: 0,
            REFRESH_STRUCTURE: 1,
            REFRESH_MODEL: 2,
            REFRESH_NONE: 3,
            REFRESH_INIT: 4,
            REFRESH_INIT_DONE: 5
        });
})();